import { PortfolioSourcesEventsService } from '@festina/unitlink-general-types/unitlink/services/PortfolioSourcesEventsService'
import { PortfoliosSwitchSubPortfoliosService } from '@festina/unitlink-general-types/unitlink/services/PortfoliosSwitchSubPortfoliosService'
import { useCreateCommandActions } from '@festina-life/authentication'

import type { PortfolioActionProps } from '../types'

class PortfoliosSwitchSubPortfoliosServiceOverwrite extends PortfoliosSwitchSubPortfoliosService {
  static portfolioSourcesServiceDeleteCancelEvent =
    PortfolioSourcesEventsService.portfolioSourcesServiceDeleteCancelEvent

  static portfolioSourcesServiceDeleteCancelEvent_roles =
    PortfolioSourcesEventsService.portfolioSourcesServiceDeleteCancelEvent_roles

  static portfolioSourcesServicePutEvents = ({
    requestBody: commandData,
    ...rest
  }: Parameters<
    typeof PortfoliosSwitchSubPortfoliosService.portfolioSwitchSubPortfolioServicePostEntity
  >[0] & { eventId: string }) =>
    PortfolioSourcesEventsService.portfolioSourcesServicePutEvents({
      ...rest,
      requestBody: {
        _type: 'UpdateSwitchSubPortfolioCommand',
        commandData,
      },
    })

  static portfolioSourcesServicePutEvents_roles =
    PortfolioSourcesEventsService.portfolioSourcesServicePutEvents_roles
}

export const useSwitchSubPortfolioActions = (
  serviceArguments: PortfolioActionProps,
) =>
  useCreateCommandActions({
    component: 'unitLink',
    service: PortfoliosSwitchSubPortfoliosServiceOverwrite,
    methods: {
      create: 'portfolioSwitchSubPortfolioServicePostEntity',
      cancel: 'portfolioSourcesServiceDeleteCancelEvent',
      update: 'portfolioSourcesServicePutEvents',
    },
    serviceArguments: {
      ownerId: serviceArguments.ownerId,
      eventId: serviceArguments.commandId ?? '', // will be there when needed
    },
  })
